<template>
  <div class="score-modal">
    <div class="modal" v-if="activityDetial.type == 1 && isAddStudent">
      <div class="modal-wraper">
        <div class="modal-body">
          <i18n class="random-select" tag="div" path="grade.randomChooseInput">
            <input
              slot="input"
              class="input-text"
              v-model="curCount"
              @input="checkInput"
              type="text"
              :class="{'err-random':curCountErrTip}"
            />
          </i18n>
          <p class="err-tip" v-if="curCountErrTip">{{curCountErrTip}}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="button button-red-solid confirm-btn"
            @click="getRandomCount"
          >{{ $t("system.confirm") }}</button>
          <button
            type="button"
            class="button button-red-hollow"
            @click="closeModal"
          >{{ $t("system.cancel") }}</button>
        </div>
        <div class="close" @click="closeModal">
          <span class="iconfont icon-guanbi"></span>
        </div>
      </div>
    </div>
    <div class="modal" v-if="activityDetial.type == 1 && !isAddStudent">
      <div class="modal-wraper custom-operation-modal big-modal">
        <div class="modal-header">
          <span class="iconfont icon-guanbi close" @click="closeModal"></span>
          <h4 class="modal-title">{{ $t("grade.chooseStu") }}</h4>
        </div>
        <div class="modal-body">
          <div class="action-wra clearfix">
            <select class="custom-select left" v-model="curClass.classId" @change="searchStudent">
              <option
                v-for="(item, index) in classList"
                :key="'class' + index"
                :value="item.classId"
              >{{item.className}}</option>
            </select>
            <!-- <div class="input-search-group">
              <input type="text" class="text-input text-input-gray" v-model="keyWord" @keyup.13="searchStudent" placeholder="输入学号/姓名搜索">
              <span class="glyphicon glyphicon-search icon-sousuo3 iconfont" @click="searchStudent"></span>
            </div>-->
          </div>
          <div class="list-wra">
            <ul class="list clearfix">
              <li class="item left" v-for="(item, index) in list" :key="'list' + index">
                <div class="checkbox custom-checkbox ellipsis-one">
                  <label>
                    <input
                      type="checkbox"
                      class="checkbox"
                      :disabled="item.isSelected"
                      :checked="item.checked"
                      @change="changeSelect(item)"
                    />
                    <span class="iconfont icon-zhongduigou mark"></span>
                    <span class="student-name ellipsis-one" :title="item.userName">{{item.userName}}</span>
                    <span class="gray">{{ $t("grade.stuNum") }}{{item.studentId}}</span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <Page
            v-if="total > 0"
            :total="total"
            :current="pn"
            :page-size="20"
            :prev-text="$t('system.previousPage')"
            :next-text="$t('system.nextPage')"
            class-name="page"
            show-elevator
            @on-change="pageChange"
          />
          <p class="empty" v-if="!list && !isLoading">{{ $t("grade.noStu") }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="button button-red-solid confirm-btn"
            @click="confirmAdd"
          >{{ $t("system.confirm") }}</button>
          <button
            type="button"
            class="button button-red-hollow"
            @click="closeModal"
          >{{ $t("system.cancel") }}</button>
        </div>
      </div>
    </div>
    <div class="modal" v-if="activityDetial.type == 2">
      <div class="modal-wraper custom-operation-modal big-modal">
        <div class="modal-header">
          <span class="iconfont icon-guanbi close" @click="closeModal"></span>
          <h4 class="modal-title">{{ $t("grade.chooseGroup") }}</h4>
        </div>
        <div class="modal-body">
          <div class="action-wra clearfix">
            <select class="custom-select left" v-model="curClass.classId" @change="searchByClass">
              <option
                v-for="(item, index) in classList"
                :key="'class' + index"
                :value="item.classId"
              >{{item.className}}</option>
            </select>
          </div>
          <div class="list-wra">
            <ul class="list clearfix">
              <li class="item left group" v-for="(item, index) in list" :key="'list' + index">
                <div class="checkbox custom-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      class="checkbox"
                      :disabled="item.isSelected"
                      :checked="item.checked"
                      @change="changeSelect(item)"
                    />
                    <span class="iconfont icon-zhongduigou mark"></span>
                    <span class="ellipsis-one left name" :title="item.title">{{item.title}}</span>
                    <span
                      class="gray ellipsis-one left members"
                      :title="_getMembers(item.groupMembers)"
                    >{{ $t("grade.member") }}{{_getMembers(item.groupMembers)}}</span>
                    <span
                      class="gray ellipsis-one left class"
                      :title="item.className"
                    >{{ $t("grade.classes", { className: item.className }) }}</span>
                  </label>
                </div>
              </li>
            </ul>
            <p class="empty" v-if="list.length == 0 && !isLoading">{{ $t("grade.noClass") }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="button button-red-solid confirm-btn"
            @click="confirmAddGroup"
          >{{ $t("system.confirm") }}</button>
          <button
            type="button"
            class="button button-red-hollow"
            @click="closeModal"
          >{{ $t("system.cancel") }}</button>
        </div>
      </div>
    </div>
    <div class="modal" v-if="activityDetial.type == 3">
      <div class="modal-wraper">
        <div class="modal-body">
          <div
            class="options clearfix"
            v-for="(item,index) in optionList"
            :key="'object-item' + index"
          >
            <span class="index left">{{index+1}}</span>
            <input
              class="input content-input left"
              type="text"
              :placeholder="$t('grade.enterObject')"
              v-model.trim="item.name"
              @input="checkNameInput(index)"
            />
            <span class="iconfont icon-lei_guanbi left" v-if="index>=1" @click="delObjItem(index)"></span>
          </div>
          <span class="add-score" @click="addObjItem">
            <i class="iconfont icon-jiahao"></i>
            {{ $t("system.addObject") }}
          </span>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="button button-red-solid confirm-btn"
            @click="confirmAddObject"
          >{{ $t("system.confirm") }}</button>
          <button
            type="button"
            class="button button-red-hollow"
            @click="closeModal"
          >{{ $t("system.cancel") }}</button>
        </div>
        <div class="close" @click="closeModal">
          <span class="iconfont icon-guanbi"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: Number,
    activityId: Number,
    isAddStudent: Boolean
  },
  data() {
    return {
      userId: this.common.getCookie("userId"),
      maxCount: 0,
      classList: [
        {
          classId: -1,
          className: this.$t("system.allClasses")
        }
      ],
      curClass: {
        classId: -1,
        className: this.$t("system.allClasses")
      },
      curCount: 1,
      selectedList: [],
      list: [],
      modalSelectedList: [],
      activityDetial: {},
      pn: 1,
      keyWord: "",
      total: 0,
      optionList: [
        {
          id: 0,
          name: this.$t("grade.object") + "1"
        }
      ],
      curCountErrTip: "",
      allGroupList: [],
      isLoading: true
    };
  },
  created() {
    this.getScoreDetail();
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    getScoreDetail() {
      var self = this;
      self.$http
        .get(
          `${self.baseURL1}/classscore/getDetail?userId=${self.userId}&id=${self.activityId}&roleId=9`
        )
        .then(res => {
          self.activityDetial = res.data;
          self.modalSelectedList = res.data.evaluate || [];
          for (var i = 0; i < self.modalSelectedList.length; i++) {
            this.$set(self.modalSelectedList[i], "checked", true);
            this.$set(self.modalSelectedList[i], "isSelected", true);
          }
          self.$emit("pushDetial", res.data);
          if (self.activityDetial.type === 2) {
            this.getGroupList();
          } else if (self.activityDetial.type === 1 && !self.isAddStudent) {
            this.goSelect();
          }
        });
    },
    getRandomArrayElements(arr, count) {
      let shuffled = arr.slice(0),
        i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    getRandomCount() {
      const self = this;
      self.$http
        .get(
          `${self.baseURL1}/classscore/randomChoosePerson?userId=${self.userId}&id=${self.activityId}`
        )
        .then(res => {
          let choosableCount = res.data.choosableCount;
          let randomChooseList = res.data.students;
          if (Number(self.curCount) > choosableCount) {
            this.$Message.warning(
              this.$t("grade.tip1") +
                `${choosableCount}` +
                this.$t("grade.tip2")
            );
            return;
          }
          let randomArr = this.getRandomArrayElements(
            randomChooseList,
            Number(self.curCount)
          );
          this.saveSelectedPerson(randomArr);
        });
    },
    getStudentList() {
      const self = this;
      self.$http
        .get(
          `${self.baseURL1}/classscore/appointChoosePerson?userId=${self.userId}&id=${self.activityId}&pn=${self.pn}&classId=${self.curClass.classId}&keyword=${self.keyword}`
        )
        .then(res => {
          if (self.isLoading) {
            self.classList = self.classList.concat(res.data.classes || []);
          }
          let students = res.data.students;
          if (students && students.length !== 0) {
            students.forEach(student => {
              if (student.isChoosed) {
                student.checked = true;
                student.isSelected = true;
              }
              self.modalSelectedList.forEach(model => {
                if (student.userId === model.userId) {
                  student.checked = true;
                }
              });
            });
          }
          self.list = students;
          self.total = res.data.total;
          self.isLoading = false;
        });
    },
    getGroupList() {
      const self = this;
      self.classList = [
        {
          classId: -1,
          className: this.$t("system.allClasses")
        }
      ];
      self.$http
        .get(`${self.baseURL1}/classscore/getClassGroups?id=${self.activityId}`)
        .then(res => {
          let classList = [];
          let list = res.data.classes;
          let groupList = [];
          list.forEach(item => {
            classList.push({
              classId: item.classId,
              className: item.className
            });
            if (item.groups && item.groups.length !== 0) {
              item.groups.forEach(group => {
                if (group.selected) {
                  group.checked = true;
                  group.isSelected = true;
                }
                self.modalSelectedList.forEach(model => {
                  if (group.groupId === model.groupId) {
                    group.checked = true;
                  }
                });
                group.className = item.className;
                group.classId = item.classId;
                groupList.push(group);
              });
            }
          });
          self.list = groupList;
          self.allGroupList = groupList;
          self.classList = self.classList.concat(classList);
          self.isLoading = false;
        });
    },
    goSelect() {
      const self = this;
      self.pn = 1;
      self.keyword = "";
      self.curClass = {
        classId: -1,
        className: this.$t("system.allClasses")
      };
      self.showSelectModal = true;
      self.getStudentList();
    },
    pageChange(pn) {
      this.pn = pn;
      this.getStudentList();
    },
    searchStudent() {
      this.pn = 1;
      this.getStudentList();
    },
    checkNameInput(index) {
      let name = this.optionList[index].name;
      name = name.replace(",", "");
      this.$set(this.optionList[index], "name", name);
    },
    changeSelect(item) {
      if (typeof item.checked === "undefined") {
        item.checked = true;
      } else {
        item.checked = !item.checked;
      }
      if (item.checked) {
        this.modalSelectedList.push(item);
      } else {
        let index = this.modalSelectedList.findIndex(model => {
          return model.userId === item.userId;
        });
        if (index !== -1) {
          this.modalSelectedList.splice(index, 1);
        }
      }
    },
    saveSelectedPerson(arr) {
      let tempArr = [];
      for (let i = 0; i < arr.length; i++) {
        tempArr.push(arr[i].userId);
      }
      let data = {
        userIds: tempArr.join(","),
        id: this.activityId
      };
      this.$http
        .post(
          `${this.baseURL1}/classscore/saveSelectedPerson?userIds=${data.userIds}&id=${data.id}`
        )
        .then(res => {
          this.successFun();
        });
    },
    confirmAdd() {
      let arr = this.modalSelectedList.filter(student => {
        return !student.isSelected && student.checked;
      });
      this.saveSelectedPerson(arr);
    },
    searchByClass() {
      const self = this;
      if (self.curClass.classId > 0) {
        let list = self.allGroupList.filter(group => {
          return group.classId == self.curClass.classId;
        });
        self.list = list;
      } else {
        self.list = self.allGroupList;
      }
    },
    //选择小组
    _getMembers(students) {
      if (!students) return "";
      let names = [];
      students.forEach(stu => {
        names.push(stu.userName);
      });
      return names.length > 0 ? names.join(",") : this.$t("grade.noMember");
    },
    //保存小组
    confirmAddGroup() {
      let groups = this.modalSelectedList.filter(group => {
        return !group.isSelected && group.checked;
      });
      let tempArr = [];
      for (let i = 0; i < groups.length; i++) {
        tempArr.push(groups[i].groupId);
      }
      let data = {
        groupIds: tempArr.join(","),
        id: this.activityId
      };
      this.$http
        .post(
          `${this.baseURL1}/classscore/saveSelectedGroups?groupIds=${data.groupIds}&id=${data.id}`
        )
        .then(res => {
          this.successFun();
        });
    },
    //保存评价对象
    confirmAddObject() {
      const self = this;
      let names = [];
      for (let i = 0; i < this.optionList.length; i++) {
        names.push(this.optionList[i].name);
      }
      let data = {
        names: names.join(","),
        id: this.activityId
      };
      this.$http
        .post(
          `${self.baseURL1}/classscore/saveCustomObject?names=${data.names}&id=${data.id}`
        )
        .then(res => {
          this.successFun();
        });
    },
    //添加评分对象
    addObjItem() {
      let length = this.optionList.length + 1;
      let name = this.$t("grade.object") + `${length}`;
      this.optionList.forEach(option => {
        if (option.name == name) {
          length++;
          name = this.$t("grade.object") + `${length}`;
        }
      });
      this.optionList.push({
        id: 0,
        name: name
      });
    },
    delObjItem(index) {
      this.optionList.splice(index, 1);
    },
    checkInput() {
      let reg = /^\d{1,2}$/g;
      if (!reg.test(this.curCount)) {
        this.curCountErrTip = this.$t("grade.tip3");
      } else if (this.curCount < 1) {
        this.curCountErrTip = this.$t("grade.tip4") + "1";
      } else if (this.curCount > 10) {
        this.curCountErrTip = this.$t("grade.tip5") + "10";
      } else {
        this.curCountErrTip = "";
      }
    },
    successFun() {
      this.$Message.success(this.$t('system.success'));
      this.closeModal();
      this.$router.replace(`/screenIndex/score`);
    }
  },
  computed: {
    studentText() {
      let length = this.modalSelectedList.length || 0;
      return length
        ? `${this.modalSelectedList[0].userName}${this.$t('system.xpeople', { num: length })}`
        : this.$t("grade.chooseStu");
    }
  }
};
</script>
<style scoped lang="scss">
@import "scoreModal.scss";
</style>





// WEBPACK FOOTER //
// src/components/scoreModal/scoreModal.vue